import React from 'react';
import Translate from "../../../../../../../../components/Translate";
import TranslateProperty from "../../../../../../../../components/TranslateProperty";
import Input from "../../../../../../../../components-new/form/Input";
import BlueButton from "../../../../../../../../components-new/buttons/BlueButton";
import DestructiveButton from "../../../../../../../../components-new/buttons/DestructiveButton";
import Tooltip from "../../../../../../../../components-new/general/Tooltip";
import DeleteIcon from "../../../../../../../../assets/icons/DeleteIcon";

/*
 * The skills an operator can be given.
 *
 * A skill's name is editable in place, as it always was - the field in the row
 * is the name, and it saves when you leave it. It used to be a borderless,
 * transparent input on a tinted card, which gave no sign it could be typed in
 * at all; it is a proper field now.
 */
const Skills = ({
                    newSkill,
                    handleSkillInputChange,
                    handleAddSkill,
                    skills,
                    handleUpdateSkill,
                    handleDeleteSkill,
                    handleSkillOnChange
                }) => (
    <div className="stg-page">
        <div className="stg-card" style={{overflowY: 'hidden'}}>
            <div className="stg-card__head">
                <div>
                    <p className="stg-card__note"><Translate text="skillInfo"/></p>
                </div>
            </div>

            <div className="stg-add-row">
                <TranslateProperty properties={[{key: 'placeholder', value: 'skillName'}]}>
                    <Input
                        className="stg-input"
                        maxLength={40}
                        type="text"
                        value={newSkill}
                        onChange={handleSkillInputChange}
                    />
                </TranslateProperty>

                <BlueButton
                    size="md"
                    width={'120px'}
                    onClick={handleAddSkill}
                    disabled={!newSkill.trim()}
                >
                    <Translate text={'add'}/>
                </BlueButton>
            </div>

            {skills.length > 0 &&
                <div className="stg-list stg-scroll" style={{marginTop: '16px'}}>
                    {skills.map((skill) => (
                        <div key={skill.id} className="stg-row">
                            <Input
                                className="stg-input"
                                type="text"
                                maxLength={40}
                                value={skill.name}
                                onBlur={(e) => handleUpdateSkill(skill.id, e.target.value)}
                                onChange={(e) => handleSkillOnChange(skill.id, e.target.value)}
                            />

                            <div className="stg-row__actions">
                                <Tooltip text="remove" deltaY={-7}>
                                    <DestructiveButton
                                        type="button"
                                        variant="outline"
                                        size="sm"
                                        iconOnly
                                        width="32px"
                                        onClick={() => handleDeleteSkill(skill.id)}
                                    >
                                        <DeleteIcon width={18} height={18} stroke="currentColor"/>
                                    </DestructiveButton>
                                </Tooltip>
                            </div>
                        </div>
                    ))}
                </div>
            }
        </div>
    </div>
);

export default Skills;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/resources/skills/Skills.jsx